import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { actionsStatus } from "src/api/config/systemSwitch";
import Loading from "src/components/Loading";
import ActionsMainPageTable from "src/components/tables/actionsMainPageTable.mobile";
import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { selectCurrentUser } from "src/modules/users/selector";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import AddActionInModal from "../../addAction/modal/modal.mobile";

type ActionsMainPageProps = {
    id: string;
    openComponentId: string;
    setOpenComponentId: React.Dispatch<React.SetStateAction<string>>;
    email?: string;
}

const ActionsMainPage = ({id, openComponentId, setOpenComponentId, email}: ActionsMainPageProps) => {

    const [actions, setActions] = useState<any>([]);
    const currentUser: any = useAppSelector(selectCurrentUser);
    const [customLoading, setCustomLoading] = useState(true);
    const location = useLocation();

    const isOpen = openComponentId === id;
    useEffect(() => {
        if (currentUser.email) {
            setCustomLoading(true);
            getItemsRequest({
                listName: myTaskActionsListName,
                filters: {
                    ResponsibleEmail: email || currentUser.email,
                    Status: [
                        actionsStatus.notStart,
                        actionsStatus.process,
                        actionsStatus.old
                    ]}}).then((results: any) => {
                setActions([...results.items]);
                setCustomLoading(false);
            });
        }
    }, [currentUser, location]);

    return (
        <section className="mb-7.5 cursor-pointer w-full flex-col flex">
            <FlexRow onClick={() => setOpenComponentId(isOpen ? "" : id)} className="w-full flex justify-between items-center mb-5">
                <h3 className="text-[#637381] flex items-center font-medium text-[14px]">
                    Действия · {customLoading ? <>&nbsp;<Loading /></> : actions.length}
                </h3>
                {isOpen ? <ArrowUp /> : <ArrowDown />}
            </FlexRow>
            {isOpen &&
                <FlexCol className="w-full gap-5">

                    {customLoading ? (
                        <div className="mt-5 mb-5 flex items-center justify-center w-full"><Loading /></div>
                    ) : (
                        <>
                            <FlexRow className="w-full items-center justify-start bg-white p-4 rounded-lg shadow-custom">
                                <FlexCol className="gap-[10px] sm:flex-row">
                                    <span className="flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="5" fill="#DEE2E6" />
                                    </svg>&nbsp;&nbsp;<span className={`text-#DEE2E6]`}>Не начато&nbsp;&nbsp;{actions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.notStart).length}</span></span>
                                    <span className="flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="5" fill="#F2A900" />
                                    </svg>&nbsp;&nbsp;<span className={`text-[#F2A900]`}>В процессе&nbsp;&nbsp;{actions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.process).length}</span></span>
                                    <span className="flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="5" fill="#BA0C2F" />
                                    </svg>&nbsp;&nbsp;<span className={`text-[#BA0C2F]`}>Просрочено&nbsp;&nbsp;{actions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.old).length}</span></span>
                                </FlexCol>
                            </FlexRow>

                            <div className="actions-main-top w-full bg-white p-5 rounded-lg">
                                <div className="actions-main-add-btn bg-white">
                                    <AddActionInModal
                                        meetingID={0}
                                        zIndex={70}
                                        percentage="79"
                                    />
                                </div>
                            </div>

                            <ActionsMainPageTable data={actions} />
                        </>
                    )}
                </FlexCol>
            }
        </section>
    );
};

export default ActionsMainPage;
